import api, { formatApiError } from "@/lib/api";
import {
  fetchClientRepositoryConfig,
  pickClientRepositoryRootPath,
  saveClientRepositoryConfig,
} from "@/lib/clientRepositoryConfig";

function periodFromDate(dateStr) {
  const s = String(dateStr || "").slice(0, 10);
  const y = Number(s.slice(0, 4));
  const m = Number(s.slice(5, 7));
  return {
    year: Number.isFinite(y) ? y : undefined,
    month: Number.isFinite(m) ? m : undefined,
  };
}

/**
 * Comprueba que BNT.TaxRepository esté accesible para el cliente.
 * La descarga SAT en nube no depende de esta ruta; solo exportación local y archivos en disco.
 */
export async function ensureTaxRepositoryConfigured({
  clientId,
  dateStr,
  direccion = "emitido",
  promptRootPath,
}) {
  const cfg = await fetchClientRepositoryConfig(clientId);
  if (cfg?.configured && cfg?.path_exists && !cfg?.needs_relocation) {
    const { year, month } = periodFromDate(dateStr);
    const { data } = await api.get("/sat/tax-repository-config", {
      params: { client_id: clientId, year, month, direccion },
    });
    return data;
  }

  const ask = promptRootPath || pickClientRepositoryRootPath;
  const selected = String((await ask()) || "").trim();
  if (!selected) {
    throw new Error(
      "Indique la carpeta BNT.TaxRepository para exportar archivos al disco local. " +
      "Las descargas del SAT se guardan en la base de datos (nube).",
    );
  }

  try {
    const saved = await saveClientRepositoryConfig(clientId, selected);
    const { year, month } = periodFromDate(dateStr);
    const { data } = await api.get("/sat/tax-repository-config", {
      params: { client_id: clientId, year, month, direccion },
    });
    return data?.path_exists ? data : { ...saved, ...data };
  } catch (e) {
    throw new Error(formatApiError(e.response?.data?.detail) || "No se pudo configurar BNT.TaxRepository");
  }
}
